import React from "react"

import { AppInTerminalAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { inTerminal } from "@signals"



export default function InTerminalAutocomplete({ ...props }) {
    return <AppInTerminalAutocomplete
		value={inTerminal.value}
		onChange={e => inTerminal.value = e.target.value}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/terminal`}
		{...props}
	/>
}